module.exports = __webpack_public_path__ + "img/image-collection-sliding-overlays-honda.d031c0ea.png";